// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".facesheet-profile h3{margin-bottom:0;padding-bottom:10px;border-bottom:1px solid var(--color-lil-grey)}.facesheet-profile .panel-body{background:var(--color-white);border-radius:var(--border-radius-standard)}", ""]);
// Exports
module.exports = exports;
